module.exports = __webpack_public_path__ + "img/bqbj@2x.7caa39a9.png";